import { render } from "./DraggableTreeNode.vue?vue&type=template&id=3ccaaced&scoped=true"
import script from "./DraggableTreeNode.vue?vue&type=script&lang=js"
export * from "./DraggableTreeNode.vue?vue&type=script&lang=js"

import "./DraggableTreeNode.vue?vue&type=style&index=0&id=3ccaaced&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ccaaced"],['__file',"src/components/DraggableTreeNode.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3ccaaced"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3ccaaced', __exports__)) {
    api.reload('3ccaaced', __exports__)
  }
  
  module.hot.accept("./DraggableTreeNode.vue?vue&type=template&id=3ccaaced&scoped=true", () => {
    api.rerender('3ccaaced', render)
  })

}


export default __exports__